import { ButtonText } from '@components/index';
import { SearchFigma } from '@components/SearchBars';
import { beam } from '@styles/colors/themes';
import TYPOGRAPHY_FLAT from '@styles/fonts/fontsizes/typography-flat';
import { deviceTypes } from '@styles/mediaQueries';
import { cloneStyled } from '@utils/cloneStyled';
import { typeCSS } from '@utils/TypeCSS.styles';
import styled from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 11;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 1011px;
  height: 100%;
  max-height: 645px;

  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  background-color: #fafbfd;
  border-radius: 8px 0 0 8px;
  width: 260px;

  flex-shrink: 0;
  height: 100%;
  flex-direction: column;
  padding: 16px 24px 0px 24px;
  border-right: 1px solid #e9edf1;

  row-gap: 16px;
`;

export const RowDiv = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  &.title {
    justify-content: space-between;
  }
`;

export const Title = styled.p`
  display: flex;
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 18px;
  color: #1b203a;
  margin: 0;
  &.pictureName {
    font-weight: 400;
    font-size: 16px;
    ${typeCSS(TYPOGRAPHY_FLAT.p300)}
  }
`;

export const AddButton = cloneStyled(
  ButtonText,
  styled(ButtonText)`
    display: flex;
    align-items: center;
    column-gap: 8px;
    && {
      padding: 5px 0;
    }
  `,
);

export const RightContainer = styled.div`
  display: flex;
  min-width: 0px;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 16px 24px 24px;

  row-gap: 16px;

  [data-device='${deviceTypes.mobile}'] & {
    display: grid;
    grid-template-columns: 24px auto 24px;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 16px 0 24px;
    overflow: auto;

    & > * {
      grid-column: 2;
    }
    .full-bleed {
      width: 100%;
      grid-column: 1 / -1;
    }
    grid-template-rows: min-content auto min-content;
  }
`;
export const RightContainerTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 8px;
`;
export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;

export const Buttons = styled.button`
  display: flex;
  border: 0;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  /* padding-top: 5px; */
  width: 32px;
  height: 32px;
  /* margin: 8px 0; */
  border-radius: 8px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const ButtonsText = styled.div`
  display: flex;
  font-family: 'Poppins';
  font-weight: 400;
  font-size: 14px;
  margin-left: 8px;
`;

export const PicturesList = styled.div`
  display: flex;
  overflow-y: scroll;
  flex-direction: column;
  width: 100%;
  height: 500px;
  align-items: center;
  gap: 16px;

  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    background: transparent;
  }

  [data-device='${deviceTypes.mobile}'] & {
    flex-direction: row;
    overflow-x: overlay;
    height: unset;
    gap: 6px;
  }
`;

export const PicturesWrapper = styled.div`
  /* width: 212px; */
  height: 127px;
  width: 100%;
  flex-shrink: 0;

  [data-device='${deviceTypes.mobile}'] & {
    height: 72px;
    width: 121px;
  }
`;

interface IPictureButton {
  'data-selected'?: boolean;
}

export const PictureButton = styled.button<IPictureButton>`
  background-color: transparent;
  display: flex;
  border: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid transparent;
  position: relative;
  width: 100%;
  height: 100%;

  &[data-selected='true'] {
    border-color: var(--beam-color-blue-b401);

    &::after {
      content: 'SELECTED';
      display: block;
      position: absolute;
      bottom: 0;
      right: 0;
      ${typeCSS(TYPOGRAPHY_FLAT.h300)}
      color: white;
      padding: 3px 6px;
      background-color: var(--beam-color-blue-b401);

      border-top-left-radius: 8px;
    }
  }
`;

export const PictureItem = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const SelectedMark = styled.div<IPictureButton>`
  display: flex;
  align-self: flex-end;
  align-items: center;
  justify-content: flex-end;
  background-color: ${beam.color.primaryBlue};
  color: #ffffff;
  width: 68px;
  height: 24px;
  padding: 3px 6px;
  border-radius: 4px 0px 4px;
  margin-top: -25px;
  font-size: 12px;
`;

export const BigPicture = styled.div`
  width: 100%;
  display: flex;
  flex-grow: 1;
  align-items: stretch;
  justify-content: center;

  min-height: 0px;
  max-height: 100%;
  border-radius: 4px;
`;

export const Container1 = styled.div`
  display: flex;
  width: 100%;
`;

export const Divider = styled.div`
  margin-bottom: 16px;
`;

export const DividerLine = styled.div`
  width: 100%;
  border-bottom: 1px solid #e6e8f0;
`;

export const Tags = styled.div`
  display: flex;
  padding: 4px 12px;
  background-color: #edeff4;
  border-radius: 15px;
  margin-right: 8px;

  font-weight: 500;
  font-size: 14px;
  color: #474d66;
`;

export const TagsDiv = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-bottom: 16px;
  justify-content: space-between;
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #8f95b2;

  &.personName {
    color: #474d66;
  }
`;

export const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const ProfileImg = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  margin-right: 8px;
  margin-left: 8px;
`;

export const BigPictureImg = styled.img`
  object-fit: scale-down;

  width: 100%;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const InputSearch = styled.input`
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 42px;
  color: #474d66;
  font-size: 14px;
  width: 250px;

  &::placeholder {
    color: #8f95b2;
  }
`;
export const PicturesOverviewSearch = styled(SearchFigma)`
  max-width: 250px;
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 5px;
`;
